import React, { useEffect, useMemo, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { Icon } from '@iq/react-components';

import SiteFilter from '../SiteFilter';
import UserInfo from '../UserInfo';

const PageHeader = ({
  title,
  isTenantAdminView,
  children,
  sitesList = false,
  setFilter = () => '',
}) => {
  const headerRef = useRef();

  useEffect(() => {
    window.onscroll = () => {
      if (headerRef.current) {
        if (window.pageYOffset === 0 && headerRef.current.classList.contains('scroll')) {
          headerRef.current.classList.remove('scroll');
        } else if (window.pageYOffset > 0 && !headerRef.current.classList.contains('scroll')) {
          headerRef.current.classList.add('scroll');
        }
      }
    };
  }, []);

  const pageTitle = useMemo(() => {
    if (!title) {
      return null;
    }
    if (title.type === 'string') {
      return (
        <div className="page-header-left">
          <NavLink
            title={title.value}
            exact
            to={{
              pathname: `/projects/`,
            }}
          >
            <Icon
              icon="he-backwards"
              size="s"
            />
          </NavLink>
          <span>{title.value}</span>
        </div>
      );
    }
    if (title.type === 'image') {
      return (
        <img
          className="page-title"
          src={title.value}
        />
      );
    }
    return null;
  }, [title]);

  const sitesListClass = sitesList ? ' sites-list' : '';
  const tenantAdmin = isTenantAdminView ? 'tenant-admin' : '';

  return (
    <div
      ref={headerRef}
      className={`page-header-component${sitesListClass} ${tenantAdmin}`}
    >
      <div className="page-header-content-wrapper">
        {pageTitle}

        {sitesList && (
          <div className="site-list-tools">
            <SiteFilter onChange={setFilter} />
          </div>
        )}

        <div className="tools">
          <UserInfo />
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
